@if (appearance() === 'dropzone') {
  <mui-dropzone
    [label]="dropzoneLabel() ?? (translations$ | async)?.dropzoneLabel"
    [description]="acceptedFormatsLabel()"
    [disabled]="disabled()"
    [accept]="accept()"
    (onFileDrop)="onNewFiles($event)">
    @if (acceptedFormatsLabel(); as acceptedFormats) {
      <div class="accepted-formats">{{ acceptedFormats }}</div>
    }
    @if (!hideButton()) {
      <ng-container *ngTemplateOutlet="button"/>
    }
  </mui-dropzone>
} @else {
  <ng-container *ngTemplateOutlet="button"/>
}

<ng-content/>
<input
  #fileInput
  data-testid="file-input"
  hidden
  type="file"
  [accept]="accept()"
  [multiple]="multiple() ? true : null"
  (change)="onFileSelected($event)"
  (cancel)="$event.stopPropagation()"
  (click)="onFileInputClick($event)"
/>

<ng-template #button>
  <button
    mui-btn
    (click)="open()"
    [disabled]="disabled()"
    [size]="buttonSize()"
    [class.mt-3]="appearance() === 'dropzone'"
    [appearance]="buttonAppearance()">
    {{ buttonLabel() ?? (translations$ | async)?.selectButton }}
  </button>
</ng-template>
